.ForgottenYourPasswordHolder {
  margin-top: calc(6px - 20px);
}
